const AppLayout = (resolve) =>
  require(['@/components/layout/AppLayout'], resolve);
const _import = (path, subPath) =>
  require('@/components/page/sysmanagement/' +
    path +
    (subPath ? `/${subPath}` : '/index'));

const routes = {
  path: '/sysmanagement',
  name: 'sysmanagement',
  component: AppLayout,
  meta: {
    title: 'sysmanagement',
    hidden: true
  },
  redirect: '/sysmanagement/seasonadjust',
  children: [
    {
      path: 'seasonadjust',
      name: 'sysmanagement-season-adjust',
      meta: {
        title: 'sysmanagement.season-adjust',
        hidden: true,
      },
      component: _import('seasonadjust')
    },
    {
      path: 'monthadjust',
      name: 'sysmanagement-month-adjust',
      meta: {
        title: 'sysmanagement.month-adjust',
        hidden: true,
      },
      component: _import('monthadjust')
    },
    {
      path: 'systemnotice',
      name: 'sysmanagement-system-notice',
      meta: {
        title: 'sysmanagement.system-notice',
        hidden: true,
      },
      component: _import('systemnotice')
    },
    {
      path: 'privilege',
      name: 'sysmanagement-privilege',
      meta: {
        title: 'sysmanagement.privilege',
        hidden: true,
      },
      component: _import('privilege')
    },
    {
      path: 'menu',
      name: 'sysmanagement-menu',
      meta: {
        title: 'sysmanagement.menu',
        hidden: true,
      },
      component: _import('menu')
    },
    {
      path: 'role',
      name: 'sysmanagement-role',
      meta: {
        title: 'sysmanagement.role',
        hidden: true,
      },
      component: _import('role')
    },
    {
      path: 'dictlist',
      name: 'sysmanagement-dict-list',
      meta: {
        title: 'sysmanagement.dict-list',
        hidden: true,
      },
      component: _import('dictlist')
    },
    {
      path: 'emailtemplate',
      name: 'sysmanagement-email-template',
      meta: {
        title: 'sysmanagement.email-template',
        hidden: true,
      },
      component: _import('emailtemplate')
    }
  ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/sysmanagement.js